import { ApiResult, request, safeRequest } from '@synergy/api';

import { CustomerConditionsApi } from '../conditions/api/customer-conditions-api';
import { CustomerDetailOverviewApi } from '../overview/api/customer-detail-overview-api';
import { CustomerDocumentsApi } from '../documents/api/customer-detail-documents-api';
import { CustomerEmployeeApi } from '../employees/api/customer-employees-api';
import { CustomerTopicsApi } from '../topics/api/customer-topics-api';

export class CustomerDetailApi {
    constructor(protected baseUrl: string) {
        this.Overview = new CustomerDetailOverviewApi(this.baseUrl);
        this.Employees = new CustomerEmployeeApi(this.baseUrl);
        this.Conditions = new CustomerConditionsApi(this.baseUrl);
        this.Documents = new CustomerDocumentsApi(this.baseUrl);
        this.Topics = new CustomerTopicsApi(this.baseUrl);
    }

    public Overview: CustomerDetailOverviewApi;
    public Employees: CustomerEmployeeApi;
    public Conditions: CustomerConditionsApi;
    public Documents: CustomerDocumentsApi;
    public Topics: CustomerTopicsApi;

    public delete(customerId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/customers/${customerId}`),
            () => null
        );
    }

    public lockCustomer(customerId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/customers/${customerId}/lock`),
            () => null
        );
    }

    public unlockCustomer(customerId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/customers/${customerId}/unlock`),
            () => null
        );
    }
}
